<main id="reset-password" class="h-screen w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    @if (!formSuccess) {
      <div class="header-wr">
        <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg"
          [attr.alt]="'LOGIN.LOGO_ALT' | translate">
        <h2 class="text-center">{{ 'NEW_PASSWORD.TITLE' | translate }}</h2>
      </div>
      <div class="form-wr">
        @if (!formSuccess) {
          <form [formGroup]="newPasswordFormGroup" (keydown)="submitOnPressEnter($event)">
            <div class="field-wr">
              <label for="username" class="block text-sm">{{ 'NEW_PASSWORD.USERNAME' | translate }}</label>
              <div class="mt-2">
                <input id="username" name="username" type="text" autocomplete="username" formControlName="username" required class="text-field">
              </div>
            </div>
            <div class="field-wr">
              <label class="block text-sm" for="new-pass">{{ 'NEW_PASSWORD.PASSWORD' | translate }} <i class="icon icon-info"
              pTooltip="{{ 'NEW_PASSWORD.PASSWORD_TOOLTIP' | translate }}" tooltipPosition="top"></i></label>
              <input type="password" id="new-pass" formControlName="password" tabindex="18" autocomplete="off">
              @if (newPasswordFormGroup.get('password')?.invalid && (newPasswordFormGroup.get('password')?.dirty || newPasswordFormGroup.get('password')?.touched)) {
                <div class="error-hint-wr">
                  @if (newPasswordFormGroup.get('password')?.hasError('required')) {
                    <small class="p-error">
                      {{ 'NEW_PASSWORD.VALIDATE_PASSWORD' | translate }}
                    </small>
                  }
                  @if (newPasswordFormGroup.get('password')?.errors?.['invalidPassword']) {
                    <small class="p-error">
                      {{ 'NEW_PASSWORD.FORMAT_PASSWORD' | translate }}
                    </small>
                  }
                </div>
              }
            </div>
            <div class="field-wr">
              <label class="block text-sm" for="confirm-paswords">{{ 'NEW_PASSWORD.REPEAT_PASSWORD' | translate }}</label>
              <input type="password" id="confirm-password" formControlName="confirmPassword" tabindex="19" autocomplete="off">
              @if (newPasswordFormGroup.get('confirmPassword')?.touched && newPasswordFormGroup.get('confirmPassword')?.invalid) {
                <div class="error-hint-wr"
                  >
                  @if (newPasswordFormGroup.get('confirmPassword')?.touched && (newPasswordFormGroup.get('confirmPassword')?.invalid || newPasswordFormGroup.get('confirmPassword')?.dirty)) {
                    @if (newPasswordFormGroup.get('confirmPassword')?.errors?.['passwordMismatch']) {
                      <small class="p-error">{{
                        'NEW_PASSWORD.VALIDATE_PASSWORD_MATCH' | translate }}
                      </small>
                    }
                    @if (!newPasswordFormGroup.get('confirmPassword')?.errors?.['passwordMismatch'] && newPasswordFormGroup.get('confirmPassword')?.hasError('required')) {
                      <small class="p-error"
                        >
                        {{ 'NEW_PASSWORD.VALIDATE_CONFIRM_PASSWORD' | translate }}
                      </small>
                    }
                  }
                </div>
              }
            </div>
            @if (!formSuccess) {
              <div class="btn-wr mt-8 mb-6">
                <button class="btn primary-btn w-full" (click)="newPassword()">{{ 'NEW_PASSWORD.BTN_CHANGE_PASSWORD' | translate }}</button>
              </div>
            }
          </form>
        }
      </div>
    }
    @if (formSuccess) {
      <div class="header-wr">
        <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg"
          [attr.alt]="'LOGIN.LOGO_ALT' | translate">
        <h2 class="text-center">{{ 'NEW_PASSWORD.SUCCESS_TITLE' | translate }}</h2>
      </div>
      <div class="row mt-2">
        <p class="text-sm text-center">{{ 'NEW_PASSWORD.SUCCESS_DESCRIPTION' | translate }}</p>
        <div class="btn-wr mt-8 mb-2">
          <button class="btn primary-btn w-full" (click)="backToLogin()">{{ 'NEW_PASSWORD.BACK_TO_LOGIN_LINK' |
          translate }}</button>
        </div>
      </div>
    }
  </div>
</main>
